const type = 'SET_TRANSACTION_LOADING';

const setTransactionLoading = (data) => ({
  data,
  type,
});

export { type };
export default setTransactionLoading;
